export const createOnboardingApi = (apiCall: any) => ({
  submit: async (data: any) => await apiCall("/onboarding", "POST", data),
  getStatus: async () => await apiCall("/onboarding/status", "GET"),
  complete: async () => await apiCall("/onboarding/complete", "POST"),
  markWelcomeShown: async () => await apiCall("/onboarding/welcome-shown", "POST"),
  getSigningUrl: async () => await apiCall("/onboarding/signing-url", "GET"),
  getSignedContractUrl: async () =>
    await apiCall("/onboarding/signed-contract", "GET"),
});
